import script from "./MdmNavBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./MdmNavBar.vue?vue&type=script&setup=true&lang=ts"

import "./MdmNavBar.vue?vue&type=style&index=0&id=2853048a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2853048a"]])

export default __exports__